<template>
    <div class="product-stats">
        <div class="meter">
            <ul>
                <li class="plus">+</li>
                <li class="plus">++</li>
                <li class="plus">+++</li>
            </ul>
            <div class="inner"></div>
        </div>
        <stat
            v-for="(stat, index) of stats"
            :key="index"
            :stat="stat"
            :show="show"
            :delay="getDelay(index)"
        />
    </div>
</template>

<script>
import Stat from './stat';
export default {
    props: ['stats', 'show'],
    components: { Stat },
    methods: {
        getDelay(index) {
            return index * 0.1;
        }
    }
};
</script>

<style lang="scss">
@import '../assets/sass/_globals/mixins';

.product-stats {
    width: 100%;
    margin-top: 1em;
    margin-right: 0;
    margin-left: 0;
    padding: 1em 2em;
    // background-color: rgba(255, 255, 255, 0.9);

    @include at-least($tlp) {
        width: 92%;
        margin-right: 1em;
        margin-left: 0.5em;
        position: absolute;
        background-color: transparent;
    }

    .meter {
        ul {
            display: flex;
            justify-content: space-between;
            margin-left: -0.25em;
            width: 105%;
            li {
                color: #333;

                &:nth-child(2) {
                    transform: translateX(0.25em);
                }
            }
        }

        .inner {
            background-color: #dcdcdc;
            border-left: 1px solid #62bb46;
            border-right: 1px solid #62bb46;
            position: relative;
            height: 0.875em;

            &:after {
                content: '';
                position: absolute;
                left: 50%;
                top: 0;
                height: 100%;
                width: 1px;
                background-color: #62bb46;
            }
        }
    }
}
</style>
